import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import Badge from "components/bootstrap/Badge";
import Icon from "components/common/Icon";
const StyledBadge = styled(Badge)(
  ({ onClick }) => css`
    cursor: ${onClick ? "pointer" : "default"};
  `
);
const BadgeInner = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
`;
const CountBadge = ({ onClick = void 0, className = "", title = void 0, count, iconName = void 0 }, ref) => /* @__PURE__ */ React.createElement(StyledBadge, { bsStyle: "default", className, onClick, ref, title }, iconName ? /* @__PURE__ */ React.createElement(BadgeInner, null, count, /* @__PURE__ */ React.createElement(Icon, { name: iconName, size: "sm" })) : count);
export default forwardRef(CountBadge);
